import Api from '@/services/Api'
import { ToastProgrammatic as Toast } from 'buefy'

const entity = '/notificacao/'

export default {

    AlunoIndex(uuid) {
        return Api().get(`${entity}alunoindex/${uuid}`).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    }

}
